import { useMemo } from 'react';

import useViewport from 'Hooks/useViewport';

export default function useCalculateSlideWidth(
  allSlides,
  fullWidth,
  sliderGap,
  sliderWidth,
  slidesToShow,
) {
  const { isAboveMd } = useViewport();

  return useMemo(() => {
    // On mobile slides default to 85% width. This is so that the next slide is partially visible
    let width = '85%';

    // If there is only 1 slide it needs to be 100% width
    if (allSlides.length === 1) width = '100%';

    // If slidesToShow is 1 on desktop, the slide will take up 90% of the sliderWidth
    if (slidesToShow === 1 && isAboveMd) {
      width = sliderWidth * 0.9;
    }

    // If slidesToShow is 1 on desktop and fullWidth is true, the slide will take up 100% of the sliderWidth
    if (slidesToShow === 1 && isAboveMd && fullWidth) {
      width = sliderWidth;
    }

    // If slidesToShow is more than 1 on mobile, slides share 85% of the available space so that the next slide is partially visible
    if (slidesToShow > 1 && !isAboveMd) {
      width = `calc((100% - ${sliderGap * (slidesToShow - 1)}px) / ${slidesToShow})`;
    }

    // If slidesToShow is more than 1 on desktop, share the sliderWidth minus gaps with slidesToShow
    if (slidesToShow > 1 && isAboveMd) {
      width = (sliderWidth - (sliderGap * (slidesToShow - 1))) / slidesToShow;
    }

    return width;
  }, [slidesToShow, sliderGap, sliderWidth, fullWidth, allSlides, isAboveMd]);
}
